if (localStorage.getItem('email') !== null) {
    pushEnhancedConversionsData();
}

function pushEnhancedConversionsData() {
    dataLayer.push({
        'event':'SuccessfulFormSubmit',
        'enhanced_conversion_data': {
            'first_name': localStorage.getItem('first_name'),
            'last_name': localStorage.getItem('last_name'),
            'email': localStorage.getItem('email'),
            'phone_number': localStorage.getItem('phone_number'),
            'city': localStorage.getItem('city'),
            'country': localStorage.getItem('country')
        }
    });
    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    localStorage.removeItem('email');
    localStorage.removeItem('phone_number');
    localStorage.removeItem('city');
    localStorage.removeItem('country');
}